import { createContext, useContext, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const ImpersonationContext = createContext(null);

export const ImpersonationProvider = ({ children }) => {
  const [isImpersonating, setIsImpersonating] = useState(
    Boolean(localStorage.getItem("admin_token_backup"))
  );

  const startImpersonation = async (targetUser) => {
    const token = localStorage.getItem("token");

    try {
      const { data } = await axios.post(
        `${__API_URL__}/api/admin/impersonate/${targetUser.id}/`,
        {},
        { headers: { Authorization: `Token ${token}` } }
      );

      localStorage.setItem("admin_token_backup", localStorage.getItem("token"));
      localStorage.setItem("admin_user_backup", localStorage.getItem("user_data"));

      localStorage.setItem("token", data.impersonation_token);
      localStorage.setItem(
        "user_data",
        JSON.stringify({
          id: data.user.id,
          full_name: data.user.full_name,
          role: data.role,
          email: data.user.email,
          owner_id: null,
        })
      );

      window.location.assign("/");
    } catch (error) {
      toast.error("Unable to start the view-as session. Please try again.");
    }
  };

  const endImpersonation = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `${__API_URL__}/api/admin/impersonate/end/`,
        {},
        { headers: { Authorization: `Token ${token}` } }
      );
    } catch (error) {
      console.error("Failed to end the view-as session cleanly: ", error);
    } finally {
      const adminToken = localStorage.getItem("admin_token_backup");
      const adminUser = localStorage.getItem("admin_user_backup");

      if (adminToken) localStorage.setItem("token", adminToken);
      if (adminUser) localStorage.setItem("user_data", adminUser);
      localStorage.removeItem("admin_token_backup");
      localStorage.removeItem("admin_user_backup");
      setIsImpersonating(false);

      window.location.assign("/");
    }
  };

  return (
    <ImpersonationContext.Provider
      value={{ isImpersonating, startImpersonation, endImpersonation }}
    >
      {children}
    </ImpersonationContext.Provider>
  );
};

const useImpersonation = () => useContext(ImpersonationContext);
export default useImpersonation;
